module.exports = __webpack_public_path__ + "static/media/FM_EU_Conflicts_of_Interest_March_2025.c715f631.pdf";